<template>
  <FieldBox :title="$t('trade.amount')">
    <p class="total-money">
      {{ isHK ? 'HK$' : '' }} {{ totalMoney | floatNum(stock) }}
    </p>
  </FieldBox>
</template>
<script>
import { mapGetters } from 'vuex'
import { SEC_TYPE, MARKET_TYPE } from 'const/stock'
import FieldBox from '../FieldBox'

export default {
  name: 'TotalMoneyField',
  components: { FieldBox },
  computed: {
    ...mapGetters(['tradeRequest']),
    stock() {
      return this.tradeRequest.stock
    },
    order() {
      return this.tradeRequest.order
    },
    isHK() {
      return this.stock.market === MARKET_TYPE.HK
    },
    isOption() {
      return this.stock && this.stock.secType === SEC_TYPE.OPT
    },
    totalMoney() {
      // 估算价格，期权每手100股
      if (this.order.limitPrice && this.order.totalQuantity) {
        return (
          this.order.limitPrice *
          this.order.totalQuantity *
          (this.isOption ? 100 : 1)
        )
      }
      return 0
    }
  }
}
</script>
<style lang="less" scoped>
.total-money {
  height: 36px;
  line-height: 36px;
  text-align: center;
}
</style>
